"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
class AudienceLink extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mouseEventDirection: 'up',
        };
    }
    render() {
        const { style, primaryText, secondaryText } = this.props;
        const { mouseEventDirection } = this.state;
        const environments = {
            production: 'https://app.rover.io/audience/',
            staging: 'https://app.staging.rover.io/audience/',
            development: 'http://' + process.env.HOST + ':9001/audience/',
        };
        return (React.createElement("div", { style: Object.assign({ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }, style) },
            React.createElement(src_1.AudienceIcon, null),
            React.createElement(src_1.Text, { text: primaryText, size: "medium", textStyle: {
                    fontWeight: 600,
                    marginTop: 16,
                    marginBottom: 8,
                    color: src_1.graphite,
                    textAlign: 'center',
                } }),
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                }, onMouseDown: () => this.setState({
                    mouseEventDirection: 'down',
                }), onMouseUp: () => {
                    this.setState({
                        mouseEventDirection: 'up',
                    });
                    window.open(environments[process.env.NODE_ENV], 'tab');
                } },
                React.createElement(src_1.ExternalLinkIcon, { fill: mouseEventDirection === 'up' ? src_1.turquoise : src_1.aquamarine }),
                React.createElement(src_1.Text, { text: secondaryText, size: "medium", textStyle: {
                        marginLeft: 8,
                        fontWeight: 600,
                        color: mouseEventDirection === 'up' ? src_1.turquoise : src_1.aquamarine,
                    } }))));
    }
}
exports.default = AudienceLink;
